import cookies from 'js-cookie'
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import wrapWithProvider from './src/store/wrap-with-provider'
cookies.remove('sessionid') //remove sessionid cookie to prevent request error
export const wrapRootElement = wrapWithProvider
